let keys = [];

export const generateKey = window.generateKey = () => {
    let key;
    do {
        key = `${Math.random() * 10000000000000000000}`
    } while(key in keys);
    keys.push(key);
    return key;
};